import { useItem } from '@/composables/item'
import { roleService } from '@/services/api'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'
import { useAlertStore } from '../system'

export const useRoleStore = defineStore('role', () => {
	const status = ref<Api.Status>('initial')
	const { items, show, update, getItem } = useItem(roleService, 'roles', 'Role')

	function attachToModule({
		id,
		target,
		targetId,
		subTarget,
		unlimited,
	}: {
		id: number
		target: string
		targetId: number
		subTarget: string
		unlimited: boolean
	}) {
		return roleService
			.attachToModule(id, target, targetId, subTarget, {
				data: { unlimited },
			})
			.then(
				({ data }) => {
					return data
				},
				(error) => {
					useAlertStore().errorAlert(error)
					return error
				}
			)
	}
	function detachAll({
		id,
		target,
		targetId = 0,
		module = undefined,
	}: {
		id: number
		target: string
		targetId?: number
		module?: string
	}) {
		return roleService.detach(id, target, targetId, module).then(
			({ data }) => {
				return data
			},
			(error) => {
				useAlertStore().errorAlert(error)
				return error
			}
		)
	}

	return {
		status,
		items,
		show,
		update,
		getItem,
		attachToModule,
		detachAll,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useRoleStore, import.meta.hot))
}
